import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { EpisodesToutComponent } from './episodes-tout.component';
import { ProceduresListModule } from '../../procedures-list/procedures-list.module';
import { GtmModule } from '../../../directives/gtm/gtm.module';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    PageContainerModule,
    ProceduresListModule,
    GtmModule,
  ],
  providers: [],
  declarations: [EpisodesToutComponent],
  exports: [EpisodesToutComponent],
})
export class EpisodesToutModule {}
